<template>
  <div v-if="liveState" id="live-controls">
    <div class="divider"></div>

    <div class="flex flex-sb-c" style="margin-bottom:0.5rem">
      <h3 style="margin: 0">Du er chauffør</h3>
      <div class="flex flex-f-c">Åbn i Maps <InputCheck isSwitch v-model="navigate" style="margin-left:0.5rem" /></div>
    </div>
    <div class="action-button">
      <!--<AppButton @click.native="startTracking(routeId)" icon="gps_fixed" color="primary"> Track </AppButton>-->
      <AppButton v-if="!liveState.started" @click="next()" icon="time_to_leave" color="primary"> Start </AppButton>
      <AppButton v-else-if="liveState.finnished" icon="time_to_leave" color="primary">Færdig</AppButton>
      <AppButton v-else-if="!liveState?.driving" @click="next()" icon="time_to_leave" color="primary">Afgang</AppButton>
      <AppButton v-else @click="next()" icon="house" color="primary">Ankommet</AppButton>
    </div>
    <Modal v-model="outsideApp" closable>
      <template v-slot:header>
        <h2>Er du ankommet?</h2>
      </template>
      <div class="card card-small">
        <h3>{{ liveState.next.name }}</h3>
        <p>{{ liveState.next.address }}</p>
      </div>
      <template v-slot:footer>
        <AppButton @click="outsideApp = false" icon="close">Nej</AppButton>
        <AppButton @click="next()" icon="home" color="primary" class="fill-x">Ja, jeg er her nu</AppButton>
      </template>
    </Modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue'
import InputCheck from '@/components/inputs/InputCheck.vue'
import { getGoogleMapsRoutes } from '@/api/tripply/directions'
import { Route, RouteLiveState } from '@/api/tripply/models'
import * as Tripply from '@/api/tripply/live'

export default defineComponent({
  name: 'LiveControls',
  components: { InputCheck },
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: true
    }
  },
  setup(props) {
    
    const outsideApp = ref(false)
    const navigate = ref(false)

    async function next() {    
      if (navigate.value) {
        outsideApp.value = !props.liveState.driving
      } 
      getGoogleMapsRoutes(props.route.places)
      Tripply.nextPlace(props.route.id, navigate.value)
    } 

    return { next, outsideApp, navigate }
  }
})
</script>

<style lang="scss" scoped>
#live-controls {
  .action-button button {
    width: 100%;
    justify-content: center;
    height: 3rem;
  }
  
}
</style>